module.exports = __webpack_public_path__ + "static/media/icon_social_share.be27803d.svg";